import { Component, OnInit } from '@angular/core';

import { EnvironmentService } from '@patient-ui/shared-ui/utils';

/**
 * Redirect component for legacy /user-agreement route.
 * Redirects users to the new external User Agreement URL.
 */
@Component({
  selector: 'patient-ui-user-agreement-redirect',
  template: `
    <div class="container-xl mt-6">
      <div class="text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-3">Redirecting to User Agreement...</p>
      </div>
    </div>
  `,
})
export class UserAgreementRedirectComponent implements OnInit {
  constructor(private envService: EnvironmentService) {}

  ngOnInit(): void {
    // Redirect to environment-specific User Agreement URL
    const userAgreementUrl = this.envService.userAgreementUrl;
    if (userAgreementUrl) {
      window.location.href = userAgreementUrl;
    } else {
      // Fallback to production URL if environment service fails
      window.location.href =
        'https://www.labcorp.com/compliance/privacy/privacy-notice/online-services-user-agreement';
    }
  }
}
